import React, { useEffect } from "react";
import { Provider as ReduxProvider } from "react-redux";
import configureRootStore from "./redux/configureStore";
import Routing from "./routes/Routing";
import { logErrorEvent } from "./utils/AnalyticsUtil";


const { reduxStore } = configureRootStore();
localStorage.removeItem("persist:root");

const App = () => {
  useEffect(() => {
    window.onerror = (message, source, lineno, colno, error) => {
      // Log the error to Firebase Analytics
      logErrorEvent(`Error: ${message}`, source);
      return false; // Let the browser handle the error as well
    };
  }, []);

  return (
    <ReduxProvider store={reduxStore}>
      <Routing />
    </ReduxProvider>
  );
};

export default App;
